import { Navigate } from 'react-router-dom';
import { ApiError, Card, CardContent, CardHeader, CardTitle, PageTitle } from '@dataroom/shared';
import { useRecoveryContact } from '@/api/hooks';
import { ClassificationLearningCard } from '@/components/ClassificationLearningCard';
import { RecoveryContactCard } from '@/components/RecoveryContactCard';

/**
 * Firm Settings — account-level settings only an owner may change: the
 * recovery contact (ADR-0055) and cross-customer classification learning
 * (ADR-0020 phase 3). A non-owner's 403 renders a plain access message
 * (the Team page's pattern), so the nav link can stay visible for everyone.
 */
export function SettingsPage() {
  const contact = useRecoveryContact();

  if (contact.error instanceof ApiError && contact.error.status === 401) {
    return <Navigate to="/login" replace />;
  }
  if (contact.error instanceof ApiError && contact.error.status === 403) {
    return (
      <div className="mx-auto w-full max-w-container px-4 py-6 md:px-6 space-y-6">
        <Card>
          <CardHeader>
            <CardTitle as="h1">Settings</CardTitle>
          </CardHeader>
          <CardContent>
            <p className="text-sm text-muted-foreground">
              Only an owner can change your firm&apos;s settings.
            </p>
          </CardContent>
        </Card>
      </div>
    );
  }

  return (
    <div className="mx-auto w-full max-w-container px-4 py-6 md:px-6 space-y-6">
      <PageTitle>Settings</PageTitle>
      <RecoveryContactCard />
      <ClassificationLearningCard />
    </div>
  );
}
